import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InputComponent } from '../base/input.component';
import { AltNeu } from '../../core/types';
import { TextListViewComponent } from './list-view.component';

@Component({
    standalone: true,
    imports: [CommonModule, TextListViewComponent],
    selector: 'wd-an-list',
    templateUrl: 'alt-neu-list-view.component.html',
    styleUrls: ['../styles/view-only.component.css', '../styles/view.component.css'],
})
export class AltNeuListViewComponent extends InputComponent<AltNeu<string>> {
	@Input() horizontal = true;

	constructor() {
		super();
	}
}
